import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryResult} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {getPlantHierarchyUrl} from '../api'
import {PlantHierarchyNode, PlantHierarchyType} from '../types'

export const PLANT_HIERARCHY_QUERY_KEY = 'plantHierarchy'

/**
 * Suite plant hierarchy (Global → … → Plant) the user has access to.
 * Shares its cache with the Suite shell, so features reading it trigger no extra request.
 */
export const usePlantHierarchyQuery = (): UseQueryResult<PlantHierarchyNode[], AxiosError> =>
  useQuery<PlantHierarchyNode[], AxiosError>({
    queryKey: [PLANT_HIERARCHY_QUERY_KEY],
    queryFn: async () => {
      const response =
        await ApiClient.axiosInstance.get<PlantHierarchyNode[]>(getPlantHierarchyUrl())
      return response.data
    },
    staleTime: Infinity
  })

/** hierarchyId of the Global node, or null while loading / when the user has no global access */
export const useGlobalHierarchyId = (): string | null => {
  const {data} = usePlantHierarchyQuery()
  return data?.find((node) => node.type === PlantHierarchyType.Global)?.hierarchyId ?? null
}
